export * from './script-injector';
